module.exports = __webpack_public_path__ + "static/media/Basketball_1-mobile.94650102.jpg";